import { MiniContainer } from '../../Components';
import { NewsSec, ProjectRightSide, ServiceRightSide } from '../../Sections';
import { NewsHeaderSec } from '../../Sections';
import './NewsPage.css'



const NewsPage = () => {
    return (
        <div className='news-page'>
            <NewsHeaderSec />
            <MiniContainer>
                <div className="news-container">
                    <NewsSec />
                    <div className="right-side">
                        <ServiceRightSide />
                        <ProjectRightSide />
                    </div>
                </div>
            </MiniContainer>

        </div>
    )
}

export default NewsPage